/**
 * Created by Pankaj on 2020/01/02.
 */

import {ScreenBounds} from "@nolimitcity/slot-launcher/bin/display/ScreenBounds";

export class Utils {
    public static DEFAULT_SCREEN_MIN_RATIO: number = 1.6;
    public static shrinkTextWidth(text: string, textContainer: PIXI.Text, maxWidth: number): void {
        while (textContainer.width > maxWidth) {
            if (this.isString(textContainer.style.fontSize)) {
                if (textContainer.style.fontSize.indexOf("em") > -1) {
                    debugger;
                    throw new Error("Helper.shrinkTextWidth(), I am lazy so I don't want to parse em, please use number or px.");
                }
                textContainer.style.fontSize = parseInt(textContainer.style.fontSize);
            }
            textContainer.style.fontSize--;
            if (textContainer.style.fontSize <= 10) {
                textContainer.style.fontSize = 10;
                return;
            }
        }
    }

    private static isString(object: any): boolean {
        return typeof object == "string";
    }

    public static isDefaultScreenRatio(bounds: ScreenBounds): boolean {
        const max: number = Math.max(bounds.width, bounds.height);
        const min: number = Math.min(bounds.width, bounds.height);
        return (max / min) > Utils.DEFAULT_SCREEN_MIN_RATIO;
    }

    public static isIphoneScreenRatio(bounds: ScreenBounds): boolean{
        const max: number = Math.max(bounds.width, bounds.height);
        const min: number = Math.min(bounds.width, bounds.height);
        return (max / min) > Utils.DEFAULT_SCREEN_MIN_RATIO;
    }

    public static padZero(value: number): string {
        return value.toString().padStart(2, "0");
    }

    public static floorPos(value : number) : number{
        return Math.floor(value);
    }

    public static  getMaxFromArray<T>(arr : T[]) : number{
        let max = Number.MIN_VALUE;
        for(let i = 0; i<arr.length; i++){
            max = Math.max(max , +arr[i]);
        }
        return max;
    }
}